import React from 'react';
import Label from '../label/Label';
import ChooseGroupPopup from '../../popups/chooseGroupPopup/ChooseGroupPopup';
import history from '../../history';
import userGroupSettingsManager from '../../utils/UserGroupSettingsManager';

const SettingsTabBar = ({ userGroup }) => {
	const narcLockEnabled = userGroup?.['narc_lock_integration_enabled'] || false;
	const currentPath = window.location.pathname;

	const getActiveCard = () => {
		if (currentPath === '/settings/general') return 'permission';
		if (currentPath === '/settings/drugs') return 'drug';
		if (currentPath === '/settings/notifications') return 'notifications';
		if (currentPath === '/settings/integrations') return 'integrations';
		if (currentPath === '/settings/sensors') return 'credentials';
		return 'permission';
	};

	const activeCard = getActiveCard();

	const navigateToSettings = (card) => {
		const routes = {
			permission: '/settings/general',
			drug: '/settings/drugs',
			notifications: '/settings/notifications',
			integrations: '/settings/integrations',
			credentials: '/settings/sensors'
		};
		if (routes[card]) {
			history.navigate(routes[card]);
		}
	};

	const renderChangeGroup = () => {
		if (!localStorage.user_group_id) return null;
		return (
			<Label
				bold
				black
				onClick={() => {
					window.popupController.show(ChooseGroupPopup, {});
				}}
			>
				Change Agency
			</Label>
		);
	};

	return (
		<div className="list">
			<Label
				onClick={() => navigateToSettings('permission')}
				bold
				blue={activeCard === 'permission'}
				black={activeCard !== 'permission'}
			>
				General Settings
			</Label>
			<Label
				onClick={() => navigateToSettings('drug')}
				bold
				blue={activeCard === 'drug'}
				black={activeCard !== 'drug'}
			>
				Available Drugs
			</Label>
			<Label
				onClick={() => navigateToSettings('notifications')}
				bold
				blue={activeCard === 'notifications'}
				black={activeCard !== 'notifications'}
			>
				Notifications
			</Label>
			{!!narcLockEnabled && (
				<Label
					onClick={() => navigateToSettings('integrations')}
					bold
					blue={activeCard === 'integrations'}
					black={activeCard !== 'integrations'}
				>
					Integrations
				</Label>
			)}
			{Boolean(userGroupSettingsManager.getSetting('allow_temperature_sensor')) && (
				<Label
					onClick={() => navigateToSettings('credentials')}
					bold
					blue={activeCard === 'credentials'}
					black={activeCard !== 'credentials'}
				>
					Sensors
				</Label>
			)}
			{renderChangeGroup()}
		</div>
	);
};

export default SettingsTabBar;




// WEBPACK FOOTER //
// ./src/components/settingsTabBar/SettingsTabBar.jsx